export const elements = {
  appContainer: document.getElementById("appContainer"),
  themeToggle: document.getElementById("themeToggle"),
  navToggle: document.getElementById("navToggle"),
  nav: document.getElementById("nav"),
  themeContext: document.getElementById("themeContext"),
  currentWordDisplay: document.getElementById("currentWord"),
  userInput: document.getElementById("userInput"),
  essayDisplay: document.getElementById("essayDisplay"),
  wordPool: document.getElementById("wordPool"),
  scoreEl: document.getElementById("scoreValue"),
  healthEl: document.getElementById("healthValue"),
  wpmEl: document.getElementById("wpmValue"),
  progressBarContainer: document.getElementById("progress"),
  progressBar: document.getElementById("progressBar"),
  modal: document.getElementById("gameOverModal"),
  title: document.getElementById("gameOverTitle"),
  finalScoreEl: document.getElementById("finalScore"),
  finalWPMEl: document.getElementById("finalWPM"),
  playerNameInput: document.getElementById("playerName"),
  saveScore: document.getElementById("saveScore"),
  playAgain: document.getElementById("playAgain"),
  leaderboardList: document.getElementById("leaderboardList"),
  leaderboardFilter: document.querySelectorAll(".lb-filter"),
  modalCloseBtns: document.querySelectorAll(".modal-close"),
  difficultyBtns: document.querySelectorAll(".difficulty-btn"),
  modeBtns: document.querySelectorAll(".mode-btn"),
  modeHint: document.getElementById("modeHint"),
  inputHint: document.getElementById("inputHint"),
  resetBtn: document.getElementById("resetGame"),
  skipBtn: document.getElementById("skipWord"),
  commandTrigger: document.querySelector(".command-trigger"),
};
